<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eHxV3p/images/cover.jpg?1730635490054" alt="This image is the cover for the book Muse in You"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Muse in You
      </h1>
      <p class="bookDescription body article font2">
        <p>Everything we do is creative: the way we think, the way we problem solve, the way we make the most of our lives. But when we experience challenging times, difficult life transitions, or grief from a loss, it’s easy for creativity to vanish and disquiet to settle in. In this guidebook to your emotional health, creativity expert Lynn Newman sends a powerful message: it is possible for you to remake your life into something extraordinary. Through personal stories, exercises, meditations, and inspired questions, learn to create a life on purpose by transcending conflict to find peace and happiness, unleashing the truest parts of yourself to experience more passion and ease, enjoying more fulfilling relationships, and following curiosity to jumpstart your creative journey. If you’re ready to shine more brightly, these lessons are your loving reminders that you are a creative being ready to accomplish your dreams! There is a muse in you!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lynn Newman
      </h2>
      
      <p class="authorDescription body article">Lynn Newman is a creativity expert with a Bachelor of Fine Arts and a masters in counseling psychology. She is the author and creator of The Game of You and The Game of Insight.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Schiffer Publishing, Ltd.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?38848c08